import { render, staticRenderFns } from "./LmParcelariasNewOrEdit.vue?vue&type=template&id=6c17384b&scoped=true&"
import script from "./LmParcelariasNewOrEdit.vue?vue&type=script&lang=js&"
export * from "./LmParcelariasNewOrEdit.vue?vue&type=script&lang=js&"
import style0 from "./LmParcelariasNewOrEdit.vue?vue&type=style&index=0&id=6c17384b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c17384b",
  null
  
)

export default component.exports